<div class="result-dialog-wrapper">
  <div class="result-dialog">
    <header class="dialog-header">
      <button class="back-button" (click)="close()">
        <mat-icon svgIcon="arrow-back"></mat-icon>
      </button>
    </header>

    <h3 class="header-text">{{ header }}</h3>

    <div class="result-content">
      <img class="emoji" [ngSrc]="imageSrc" alt="result emoji" width="184" height="184"/>

      <div class="title-score-container">
        <div class="title">{{ title }}</div>
        <div class="score">{{ scoreText }}</div>
      </div>

      <div class="message">{{ message }}</div>
    </div>

    <div class="actions">
      <button class="action-btn continue-btn" (click)="close()">Continue</button>
      <button class="action-btn share-btn">
        <mat-icon svgIcon="upload-white"/>
        Share
      </button>
    </div>
  </div>
</div>
